
const About = () => {
  return (
    <section id="sobre-psicologa" className="py-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-800 mb-6">
            Conoce a tu Psicóloga
          </h3>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Imagen de la psicóloga */}
          <div className="order-2 lg:order-1">
            <div className="relative">
              <img
                src="/yalimar-ruiz-psicologa.jpg"
                
                alt="Dra. Yalimar Ruiz - Psicóloga Clínica"
                className="w-full rounded-2xl shadow-2xl object-cover object-top"
              />
              <div className="absolute -bottom-6 -right-6 bg-green-700 text-white p-6 rounded-2xl shadow-xl" style={{backgroundColor: '#678E2A'}}>
                <div className="text-center">
                  <div className="text-2xl font-bold">8+</div>
                  <div className="text-sm">Años de experiencia</div>
                </div>
              </div>
            </div>
          </div>

          {/* Información de la psicóloga */}
          <div className="order-1 lg:order-2 space-y-8">
            <div>
              <h4 className="text-3xl font-bold text-gray-800 mb-4">
                Dra. Yalimar Ruiz
              </h4>
              <p className="text-xl font-medium mb-6" style={{color: '#678E2A'}}>
                Psicóloga Clínica
              </p>
              
              <div className="prose prose-lg text-gray-600">

                <p className="mb-6 text-justify">
Hola, soy psicologa clínica con especialización en evaluación y diagnostico de la personalidad. Mi experiencia se centra en el abordaje terapéutico de la depresión, ansiedad, autoestima y tipos de apego.
                </p>
                
                <p className="mb-6 text-justify">
Mi intención es acompañarte y brindarte un espacio seguro a lo largo de tu proceso. En nuestras sesiones lograremos identificar síntomas, ideas y conductas que necesiten ser reestructuradas para generar nuevas habilidades de afrontamiento para lograr tu bienestar.
Todos atravesamos momentos difíciles y hablar con un profesional te ayudará a procesar lo que sientes 

                </p>
              </div>
            </div>

            {/* Educación y certificaciones */}
            <div className="space-y-6">

              {/* Especialidades */}
              <div>
                <h5 className="text-lg font-semibold text-gray-800 mb-4">Especialidades</h5>
                <div className="flex flex-wrap gap-3">
                  {[
                    'Ansiedad y Depresión',
                    'Terapia de Pareja',
                    'Conflictos Familiares', 
                    'Autoestima',
                    'Gestión del Estrés',
                    'Duelo y Pérdida'
                  ].map((specialty, index) => (
                    <span 
                      key={index}
                      className="px-4 py-2 rounded-full text-sm font-medium text-white"
                      style={{backgroundColor: '#678E2A'}}
                    >
                      {specialty}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            {/* Quote */}
            <div className="bg-white rounded-xl p-6 shadow-lg border-l-4" style={{borderLeftColor: '#678E2A'}}>
              <p className="text-gray-700 italic text-lg mb-4">
                 “TU SALUD MENTAL TAMBIÉN MERECE UN ESPACIO”
              </p>
              <p className="font-semibold" style={{color: '#678E2A'}}>- Dra. Yalimar Ruiz</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
